import mime from 'mime-types';

export const mimeTypeFormatter: Record<string, string> = {
  'application/zip-compressed': 'application/zip',
  'application/x-zip-compressed': 'application/zip',
  'video/x-m4v': 'video/mp4',
  'video/3gpp': 'video/mp4',
  'video/avi': 'video/x-msvideo',
  // ubuntu specific
  'video/vnd.avi': 'video/x-msvideo',
};

export const DEFAULT_MIME = 'application/octet-stream';

type ContentTypeMedia = {
  filename?: string;
  contentType?: string;
  file?: Pick<File, 'name' | 'type'>;
  media?: { filename?: string };
};

export const getContentType = (media: ContentTypeMedia, defaultValue: string | null = DEFAULT_MIME): string | null => {
  const name = media.filename ?? media.file?.name ?? media.media?.filename;

  // mime.lookup returns string | false
  const mimeFromFilename = mime.lookup(name ?? '') || undefined;

  // file.type can be "" when the browser can't detect the MIME, normalizes that to undefined
  const fileType = media.file?.type || undefined;
  const computedMimeType = fileType ?? media.contentType ?? mimeFromFilename ?? defaultValue;

  return computedMimeType ? mimeTypeFormatter[computedMimeType] ?? computedMimeType : computedMimeType;
};
